export const apiConfig = {
    accountSettings: (): string => {
        throw new Error("You haven't set the accountSettings endpoint");
    },
    digestStatus: (): string => {
        throw new Error("You haven't set the digestStatus endpoint");
    },
    grantedTemporaryAccessDetails: (): string => {
        throw new Error("You haven't set the grantedTemporaryAccessDetails endpoint");
    },
    temporaryAccessSettings: (): string => {
        throw new Error("You haven't set the temporaryAccessSettings endpoint");
    },
    temporaryAccessAdmins: (): string => {
        throw new Error("You haven't set the temporaryAccessAdmins endpoint");
    },
    grantEmailTemporaryAccess: (): string => {
        throw new Error("You haven't set the grantEmailTemporaryAccess endpoint");
    },
    grantAdminTemporaryAccess: (): string => {
        throw new Error("You haven't set the grantAdminTemporaryAccess endpoint");
    },
    extendTemporaryAccess: (_tempAccessId: string): string => {
        throw new Error("You haven't set the extendTemporaryAccess endpoint");
    },
    revokeTemporaryAccess: (_tempAccessId: string): string => {
        throw new Error("You haven't set the revokeTemporaryAccess endpoint");
    },
    getAuthorisedDevices: () => {
        throw new Error("You haven't set the getAuthorisedDevices endpoint");
    },
    revokeDeviceAccess: (_id: string): string => {
        throw new Error("You haven't set the revokeDeviceAccess endpoint");
    }
};
